module.exports = __webpack_public_path__ + "static/img/product_society_society_yjgl3.3a500f5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_yjgl3.svg
// module id = xWGs
// module chunks = 0